<template>
  <div>
    <div class="badge-detail__form">
      <div class="kl-form badge-detail__info-col">
        <div class="kl-form__row">
          <div class="kl-form__col">
            <kd-input-container>
              <label>{{Kadenze.I18n.t('dict.name_label')}}</label>
              <kd-input v-model='title'></kd-input>
            </kd-input-container>
          </div>
        </div>

        <div class="kl-form__row">
          <div class="kl-form__col">
            <kd-input-container>
              <label>{{Kadenze.I18n.t('dict.description_label')}}</label>
              <textarea class='kd-textarea' v-model='description'></textarea>
            </kd-input-container>
          </div>
        </div>
      </div>

      <div class='badge-detail__dz-col'>
        <div class='dropzone__img' id='badge-dz'></div>
      </div>
    </div>

    <div class='kl-form__row--right'>
      <div class='kd-panel__footer_primary-btns'>
        <a class="inline-block-link--del typo__body--reg"
           href="javascript:;"
           @click="$emit('close')">{{Kadenze.I18n.t('dict.cancel')}}</a>
        <a class="inline-block-link typo__body--reg" href="javascript:;" @click='save'>{{Kadenze.I18n.t('dict.save')}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    badge: Object
  },
  data() {
    return {
      courseId: null,
      title: "",
      description: "",
      imagePath: "",
      imageUrl: "",
      removeImage: false,
      dz: null
    }
  },
  mounted() {
    if ( this.badge ) {
      this.bindData(this.badge);
    }
    console.log(this.badge)
    this.courseId = Kadenze.Util.getCourseIdFromPath();
    this.$nextTick(() => {
      this.initDZ();
      (new Kadenze.KdForms()).init();
    });
  },
  methods: {
    bindData(d) {
      this.title = d.title;
      this.description = d.description;
      this.id = d.id;
      if ( d.image ) {
        this.imageUrl = d.image.url;
      }
    },
    save() {
      let url = Kadenze.Routes.course_badges_path(this.courseId);
      let method = 'POST';

      if (this.id) {
        url = Kadenze.Routes.course_badge_path(this.courseId, this.id);
        method = 'PATCH';
      }

      new Kadenze.AjaxRequest({
        url,
        method,
        loadingIndicator: true,
        data: {
          badge: {
            title: this.title,
            description: this.description,
            remote_image_url: this.imageUrl,
            image_path: this.imagePath
          }
        }
      }).success(() => {
        this.$emit('update')
        this.$emit('close')
      }).error(resp => {
        if (resp.responseJSON) {
          new Kadenze.Notice.error({message: resp.responseJSON.errors})
        } else {
          new Kadenze.Notice.error({message: resp.responseText})
        }
      })
    },
    initDZ() {
      let self = this;
      const $el = $('#badge-dz');
      if (!$el[0].dropzone) {

        const fileObj = {
          path: this.imageUrl
        }

        $el.addClass('dz-unit');
        const acceptedFiles = '.svg,.jpg,.jpeg,.png';

        let message = JST['templates/dropzone-generic']({
          title: Kadenze.I18n.t('drop_file_editor.add_image'),
          dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
          dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
          browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
          dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
          maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
          fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
          optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
          acceptedFiles,
        });

        message = Kadenze.I18n.tt(message, 'en');

        const uploadURL = Kadenze.Routes.temp_image_upload_path();
        const callbacks = {
          success(file, response) {
            console.log('success')
            if (response.path.match(/^https?/)) {
              console.log('setting image url')
              self.imageUrl = response.path;
            } else {
              self.imagePath = response.path;
            }
            self.removeImage = false;
          },
          removedFile() {
            self.imagePath = '';
            self.removeImage = true;
          }
        }
        const opts = {
          acceptedFiles,
          dzPreview: JST['templates/dropzone-generic-img-preview']({
            hideFileStats: true,
            containerClass: 'dz-preview--badge',
            nameLabel: Kadenze.I18n.t('file_preview.name'),
            sizeLabel: Kadenze.I18n.t('file_preview.size'),
            previewLabel: Kadenze.I18n.t('file_preview.preview'),
            removeLabel: Kadenze.I18n.t('file_preview.remove_file'),
            fileUploadProgressLabel: Kadenze.I18n.t('file_preview.file_upload_progress')
          }),
          cropOptions: {
            modalId: 'crop_modal',
            aspectRatio: 1
          },
        };
        this.dz = new Kadenze.ImageDropZone($el, message, uploadURL, callbacks, fileObj, opts);
      }
    }
  }
}
</script>
